import { render, staticRenderFns } from "./Commissioners.vue?vue&type=template&id=88761516&scoped=true&"
import script from "./Commissioners.vue?vue&type=script&lang=js&"
export * from "./Commissioners.vue?vue&type=script&lang=js&"
import style0 from "./Commissioners.vue?vue&type=style&index=0&id=88761516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88761516",
  null
  
)

export default component.exports